<div class="main-section">
  <section *ngIf="this.gameConfig.sliderName === 'slider'">
    <div id="carouselExampleIndicators" class="carousel slide  hero-banner" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" *ngFor="let item of gameConfig.imageList; let i = index;"
          data-bs-target="#carouselExampleIndicators" attr.data-bs-slide-to="{{i}}"
          class="{{ (i == 0) ? 'active' : '' }}" attr.aria-label="Slide {{i}}"></button>

      </div>
      <div class="carousel-inner container">
        <ng-container *ngFor="let item of gameConfig.imageList; let i = index;">
          <div class="carousel-item" [ngClass]="{'active': i == 0}">
            <div class="row">
              <div class="col-lg-6  ps-lg-5 ps-0 order-1 order-lg-0">
                <div class="carousel-text">
                  <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                  <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                  <p>{{this.gameConfig.description}}</p>
                </div>
              </div>
              <div class="col-lg-6 text-center order-0 order-lg-1 mt-3 carousel-img">
                <img [src]="item" alt="carousel-1" class=" game-carousel" />
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </section>

  <section *ngIf="this.gameConfig.sliderName === 'noslider'">
    <div class="">
      <div class="container ">
        <div class="px-60">
          <div class="row">
            <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
              <div class="carousel-text video-text">
                <!-- <h4>{{portalName}}</h4> -->
                <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                <p>{{this.gameConfig.description}}</p>
              </div>
            </div>
            <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
              <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                <img [src]="item" class="img-fluid" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="design-responsive-1" *ngIf="this.gameConfig.sliderName === 'videoSlider'">
    <div class=" hero-banner">
      <div class="container ">
        <div class="px-60">
          <div class="row">
            <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
              <div class="carousel-text video-text">
                <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                <p>{{this.gameConfig.description}}</p> <a href="#" class="btn btn-ghost btn-post mt-0">View</a>
              </div>
            </div>
            <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
              <div class="image-warp d-flex">
                <div class="swiper mySwiper">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let item of gameConfig.imageList; let i = index;">
                      <div class="image-slider img-1">
                        <img [src]="item" alt="" class="img-fluid">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="mt-64 design-responsive">
    <div class="design-8">
      <img src="./../../assets/images/2.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title text-center">
            <h2 *ngIf="!isShow">{{account.header}}</h2>
            <h2 *ngIf="isShow">Mon compte</h2>
            <span style="background-color: red;">{{this.alertMsg}}</span>
          </div>
        </div>
        <div class="col-lg-6 mx-auto">

          <div class="container py-3">
            <div *ngIf="isShowMyAccountTable == true" class="tablerounededCorner table-responsive">
              <table  class="table table-bordered table-hover table-radius roundedTable">
                <tr *ngIf="!isShow">
                  <th scope="row" class="border-end w-50"
                    *ngIf="queryParam.id != '6' && queryParam.biller != 'TPAY' && queryParam.operator != '9073'">
                    {{account.customer}}:</th>
                  <th scope="row" class="border-end w-50" style="color: #ffffff;"
                    *ngIf="(queryParam.id == '6' || queryParam.id == '322' || queryParam.id == '298') && queryParam.biller == 'TPAY' && (queryParam.operator == '9073' || queryParam.operator == '8903' || queryParam.operator == '8966') && queryParam.lang == 'EN'">
                    Enter Mobile Number:</th>
                  <th scope="row" class="border-end w-50" style="color: #ffffff;"
                    *ngIf="(queryParam.id == '6' || queryParam.id == '322' || queryParam.id == '298') && queryParam.biller == 'TPAY' && (queryParam.operator == '9073' || queryParam.operator == '8903' || queryParam.operator == '8966')  && queryParam.lang == 'AR'">
                    أدخل رقم الهاتف المتحرك :</th>

                  <td *ngIf="queryParam.id != '6' && queryParam.biller != 'TPAY' && queryParam.operator != '9073'">
                    {{this.queryParam.mobileNumber}}</td>
                  <td
                    *ngIf="(queryParam.id == '6' || queryParam.id == '322' || queryParam.id == '298') && queryParam.biller == 'TPAY' && (queryParam.operator == '9073' || queryParam.operator == '8903' || queryParam.operator == '8966') && queryParam.lang == 'EN'">
                    <input type="text" [(ngModel)]="number" placeholder="enter msisdn" class="border-end w-100" style="color: #ffffff;
                                            border: 1px solid white">
                  </td>
                  <td
                    *ngIf="(queryParam.id == '6' || queryParam.id == '322' || queryParam.id == '298') && queryParam.biller == 'TPAY' && (queryParam.operator == '9073' || queryParam.operator == '8903' || queryParam.operator == '8966') && queryParam.lang == 'AR'">
                    <input type="text" [(ngModel)]="number" placeholder="" class="border-end w-100" style="color: #ffffff;
                                            border: 1px solid white">
                  </td>

                </tr>



                <tr *ngIf="!isShow && (queryParam.id != '484' && queryParam.biller != 'MOBIXONE')">

                  <th scope="row" class="border-end">{{account.status}} :</th>
                  <td>{{active}}</td>
                </tr>



                <tr
                  *ngIf="queryParam.id == '536' && queryParam.biller == 'Mobimind' && queryParam.serviceId == '1331' && queryParam.operator== '2022'">
                  <th scope="row" class="border-end">Subscription Date :</th>
                  <td>{{this.subData.startDt}}</td>
                </tr>

                <tr
                  *ngIf="queryParam.id == '536' && queryParam.biller == 'Mobimind' && queryParam.serviceId == '1331' && queryParam.operator== '2022'">
                  <th scope="row" class="border-end">Next Renewal Date :</th>
                  <td>{{this.subData.nextRenDt}}</td>
                </tr>


                <tr
                  *ngIf="queryParam.id == '536' && queryParam.biller == 'Mobimind' && queryParam.serviceId == '1331' && queryParam.operator== '2022'">
                  <th scope="row" class="border-end">Expiry Date :</th>
                  <td>{{this.subData.expiry_dt}}</td>
                </tr>

                <tr
                  *ngIf="queryParam.id == '536' && queryParam.biller == 'Mobimind' && queryParam.serviceId == '1331' && queryParam.operator== '2022'">
                  <th scope="row" class="border-end">Applied Plan :</th>
                  <td>{{this.subData.packid}}</td>
                </tr>


                <tr
                  *ngIf="queryParam.id == '536' && queryParam.biller == 'Mobimind' && queryParam.serviceId == '1331' && queryParam.operator== '2022'">
                  <th scope="row" class="border-end">Service Name :</th>
                  <td>{{this.subData.serviceName}}</td>
                </tr>
                <!-- <tr *ngIf="isShow">
                                    <th scope="row" class="border-end">Statut :</th>
                                    <td>Actif</td>
                                </tr> -->
                <!-- <tr class="border-bottom-0">
                                      <th scope="row" class="border-end">Last Transaction Time :</th>
                                      <td></td>

                                  </tr> -->
              </table>

              

            </div>
            <!-- <p *ngIf="queryParam.operator == 8899 && queryParam.biller == 'Mobimind' && queryParam.id =='536'" style="color:white;text-align: center;">To unsubscribe from GAMESOLUTELY send U 1 to
              802213</p>
            <p *ngIf="queryParam.operator == 8966 && queryParam.biller == 'Mobimind'  && queryParam.id =='536'" style="color:white;text-align: center;">To unsubscribe from GAMESOLUTELY send U 1 to
              709701</p>
            <p *ngIf="queryParam.operator == 8903 && queryParam.biller == 'Mobimind'  && queryParam.id =='536'" style="color:white;text-align: center;">To unsubscribe from GAMESOLUTELY send U 310 to
              670611</p>
            <p *ngIf="queryParam.operator == 2022  && queryParam.biller == 'Mobimind' && queryParam.id =='536'" style="color:white;text-align: center;">To unsubscribe from GAMESOLUTELY send Stop 1 to
              1421</p>
            <p *ngIf="queryParam.operator == 2028  && queryParam.biller == 'Mobimind' && queryParam.id =='536'" style="color:white;text-align: center;">To unsubscribe from GAMESOLUTELY send Stop 1 to
              50279</p> -->
            <div *ngIf="isShowMyAccountTable == true">
              <button  [disabled]=buttonDisabled
                *ngIf="!isShow && queryParam.id != '499' && queryParam.id !='484' &&  queryParam.biller != 'ALL' && !operatorIdsForSL.includes(queryParam.operator)"
                type="button" (click)="unsub()"
                class="btn btn-outline-success btn-border mt-3 float-end">{{account.button}}</button>
              <!-- <button *ngIf="!isShow && queryParam.id != '427' && queryParam.biller != 'MOBIXONE' && !operatorIdsForSL.includes(queryParam.operator)" type="button" (click)="unsub()" class="btn btn-outline-success btn-border mt-3 float-end">{{account.button}}</button> -->
              <button *ngIf="queryParam.id =='427' && queryParam.biller == 'MOBIXONE' && queryParam.operator == '2014'"
                type="button" (click)="unsub()" class="btn btn-outline-success btn-border mt-3 float-end">Cancel
                Subscription</button>

              <!-- <button *ngIf="queryParam.id =='484' && queryParam.biller == 'MOBIXONE' && queryParam.operator == '2015'"
                t1ype="button" (click)="unsub()" class="btn btn-outline-success btn-border mt-3 float-end">Cancel
                Subscription</button> -->
              <div
                *ngIf="queryParam.id == '499' && queryParam.biller == 'ALL' && operatorIdsForSL.includes(queryParam.operator)"
                class="text-center" style="color: #ffffff">
                <h4>To unsubscribe, send STOP PLAYPRO to 43006</h4>
              </div>
            </div>
            <div *ngIf="isShowMyAccountTable == false">
              <div class="text-center mt-5" style="color: #ffffff">
                <h4>{{unSubMessage}}</h4>
              </div>
            </div>
            <div *ngIf="isShowMyAccountTable == true && queryParam.id == '427' && queryParam.biller == 'MOBIXONE' && queryParam.operator == '2014'">
              <div class="text-center mt-5" style="color: #ffffff; padding-top: 20px;">
                <h4>{{unSubMessage}}</h4>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="row" *ngIf="queryParam.id === '414'">
        <div class="col-lg-12">
          <div class="section-title text-center">
            <h2>Mon compte</h2>
            <span style="background-color: red;">{{this.alertMsg}}</span>
          </div>
        </div>
        <div class="col-lg-6 mx-auto">

          <div class="container py-3">
            <div class="tablerounededCorner table-responsive">
              <table class="table table-bordered table-hover table-radius roundedTable">
                <tr>
                  <th scope="row" class="border-end w-50">N ° de client
                    :</th>
                  <td>{{this.queryParam.mobileNumber}}</td>
                </tr>
                <tr>
                  <th scope="row" class="border-end">statut :</th>
                  <td>{{this.queryParam.sub === true ? 'ACTIF' : 'INACTIF'}}</td>


                </tr>
                <!-- <tr class="border-bottom-0">
                                    <th scope="row" class="border-end">Last Transaction Time :</th>
                                    <td></td>

                                </tr> -->
              </table>

            </div>

          </div>


        </div>

      </div>
      <div class="container text-center mt-3">
        <p class="link" *ngIf="queryParam.id == '482' && queryParam.operator == '2123' && queryParam.biller == 'Infovas'">Go to the link <a href="http://gh.lpage.club/ads/lp/gh-vflicks">http://gh.lpage.club/ads/lp/gh-vflicks</a> to manage your services.</p>
        <p class="link" *ngIf="queryParam.id == '547' && queryParam.operator == '2123' && queryParam.biller == 'Infovas'">Go to the link <a href="http://gh.lpage.club/ads/lp/gh-gamez-hut-2">http://gh.lpage.club/ads/lp/gh-gamez-hut-2</a> to manage your services.</p>
      </div>
    </div>

    <!-- test button for  -->
    <!-- <div class="row" *ngIf="queryParam.id =='427' && queryParam.biller == 'MOBIXONE' && queryParam.operator == '2014'">
        <div class="col-lg-12">
          <div class="section-title text-center">
              <h2>My Account</h2>
              <span style="background-color: red;">{{this.alertMsg}}</span>
          </div>
      </div>
      <div class="col-lg-6 mx-auto">

          <div class="container py-3">
              <div class="tablerounededCorner table-responsive">
                  <table class="table table-bordered table-hover table-radius roundedTable">
                          <tr>
                              <th scope="row" class="border-end w-50">N ° de client
                                  :</th>
                              <td>{{this.queryParam.mobileNumber}}</td>
                              </tr>
                          <tr>
                              <th scope="row" class="border-end">statut :</th>
                              <td>{{this.queryParam.sub === true ? 'ACTIF' : 'INACTIF'}}</td>
                          </tr>
                  </table>

              </div>
              <button type="button" (click)="unsub()" class="btn btn-outline-success btn-border mt-3 float-end">Cancel Subscription</button>
          </div>
      </div>
      </div> -->
      <div *ngIf="queryParam.id == '484' && queryParam.biller == 'MOBIXONE'" class="container text-center mt-3">
        <h4 style="color: #ffffff;">To unsubscribe dial *135*997# or Dial 082 135 for Vodacom Customer Support.<br>Go to <a href="https://bit.ly/3if1lzJ">https://bit.ly/3if1lzJ</a> manage your content services</h4>
      </div>
  </section>



</div>